import { Beneficio } from './beneficio.model';

export class Pacote {
	public beneficios: Beneficio[] = [];
	public codPacote: number;
	public dtVigencia: Date;
	public nmPacote: string;
	public tpDesconto: string;
	public tpPacote: string;
	public vlrDesconto: number;
	public vlrPacote: number;
	public vlrTotDesconto: number;
	public vlrTotServicos: number;
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/rate-package/models/pacote.model.ts